import { Fonts } from '../../../../../shared/theme';
import colors from '../../../../../shared/theme/colors';

export default {
  addBranchText: {
    paddingLeft: 20,
    color: '#4B2885',
    cursor: 'pointer',
    fontFamily: 'Kanit-Regular'
  },
  addBranchTextInner: {
    textDecoration: 'underline'
  },
  option_promotion: {
    color: '#D3329A',
    fontFamily: Fonts.type.KanitMedium,
  },
  remark: {
    marginTop: 8,
    whiteSpace: 'pre-line',
    color: colors.font.primary.fakeBlack
  },
  warning: {
    marginTop: 8,
    whiteSpace: 'pre-line',
    color: colors.font.messaging.lightRed,
    textAlign: 'center',
    fontFamily: 'Kanit-Light',
    fontSize: 14
  },
  tagPickerRemark: {
    whiteSpace: 'pre-line',
    color: colors.font.messaging.lightRed,
    fontFamily: 'Kanit-Light',
    fontSize: 14
  }
};

export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

